
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/raid/[id]",
      function () {
        return require("private-next-pages/raid/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/raid/[id]"])
      });
    }
  